import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { config } from '../../config/config';
import { showToast } from '../../components/utils/Toast';

const authHeader = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const json = async (res) => {
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Request failed');
  return data;
};

export const fetchPeople = createAsyncThunk(
  'people/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetch(`${config.apiUrl}/api/people`, { headers: authHeader() });
      const data = await json(res);
      return data.people;
    } catch (e) { return rejectWithValue(e.message); }
  }
);

export const createPerson = createAsyncThunk(
  'people/create',
  async (payload, { rejectWithValue }) => {
    try {
      const res = await fetch(`${config.apiUrl}/api/people`, {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await json(res);
      return data.person;
    } catch (e) { return rejectWithValue(e.message); }
  }
);

export const updatePerson = createAsyncThunk(
  'people/update',
  async ({ id, updates }, { rejectWithValue }) => {
    try {
      const res = await fetch(`${config.apiUrl}/api/people/${id}`, {
        method: 'PUT',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(updates)
      });
      const data = await json(res);
      return data.person;
    } catch (e) { return rejectWithValue(e.message); }
  }
);

export const deletePerson = createAsyncThunk(
  'people/delete',
  async (id, { rejectWithValue }) => {
    try {
      const res = await fetch(`${config.apiUrl}/api/people/${id}`, {
        method: 'DELETE',
        headers: authHeader()
      });
      await json(res);
      return id;
    } catch (e) { return rejectWithValue(e.message); }
  }
);

const slice = createSlice({
  name: 'people',
  initialState: { items: [], loading: false, error: null },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchPeople.pending, (s) => { s.loading = true; });
    b.addCase(fetchPeople.fulfilled, (s, a) => { s.loading = false; s.items = a.payload; });
    b.addCase(fetchPeople.rejected, (s, a) => { s.loading = false; s.error = a.payload; });
    b.addCase(createPerson.fulfilled, (s, a) => {
      s.items.push(a.payload);
      s.items.sort((x, y) => (x.name || '').localeCompare(y.name || ''));
      showToast('Person added', 'success');
    });
    b.addCase(createPerson.rejected, (_, a) => { showToast(a.payload, 'error'); });
    b.addCase(updatePerson.fulfilled, (s, a) => {
      const i = s.items.findIndex((p) => p._id === a.payload._id);
      if (i >= 0) s.items[i] = a.payload;
      showToast('Person updated', 'success');
    });
    b.addCase(updatePerson.rejected, (_, a) => { showToast(a.payload, 'error'); });
    b.addCase(deletePerson.fulfilled, (s, a) => {
      s.items = s.items.filter((p) => p._id !== a.payload);
      showToast('Person removed', 'success');
    });
    b.addCase(deletePerson.rejected, (_, a) => { showToast(a.payload, 'error'); });
  }
});

export default slice.reducer;
